import { useTranslation } from "react-i18next";

/** The page a visitor sees on the link of a salon that is gone or switched
 *  off (lib/salonUnavailable.ts), in the licence screen's look. */
export default function SalonUnavailableView() {
  const { t } = useTranslation();
  return (
    <div className="font-sans" style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", minHeight: "50vh", padding: "2rem",
      textAlign: "center", color: "#374151",
    }}>
      <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔗</div>
      <h2 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: ".5rem" }}>
        {t("widget.unavailable.title", "This booking page is no longer available")}
      </h2>
      <p style={{ maxWidth: 420, color: "#6b7280" }}>
        {t("widget.unavailable.body",
          "The link may be out of date. Please contact the salon directly to make an appointment.")}
      </p>
    </div>
  );
}
